import React from 'react';
import type { IWidgetComponentProps } from '../../../IWidgetType';
import { useWidgetVisibility } from '../../../hooks/useWidgetVisibility';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import type { IQuestionWidget } from './IQuestionWidget';
import { QuestionTitle } from './style/QuestionTitle';

export interface IQuestionWidgetComponentProps
  extends IWidgetComponentProps<IQuestionWidget> {}

export function QuestionWidgetComponent(props: IQuestionWidgetComponentProps) {
  const { widget } = props;

  const options = getWidgetProps(props);
  const visible = useWidgetVisibility(props.widget, options);

  if (!visible) return null;

  return (
    <>
      <QuestionTitle
        title={widget.title}
        description={
          widget.layout?.hideDescription ? undefined : widget.description
        }
      />
      {props.children}
    </>
  );
}
